var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBurgerMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,4.04277)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,9.60478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,15.1668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurgerMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger-menu.6820e88d.svg";
export { ForwardRef as ReactComponent };